import Site from '@/models/Site'
import Board from '@/models/Board'
import Api from '@/api'
import store from '@/store'
import { findIndex, map } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    siteSelectionList: [],
    siteSelectionMeta: {},
    listMeta: {},
    siteDetails: null,
    boardList: [],
    boardListMeta: {},
    loading: false
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setSiteSelectionList(state, sites) {
      state.siteSelectionList = [
        ...state.siteSelectionList,
        ...map(sites, site => {
          if (site instanceof Site) {
            return site
          } else {
            return new Site(site)
          }
        })
      ]
    },

    setSiteSelectionMeta(state, meta) {
      state.siteSelectionMeta = meta
    },
    setSiteList(state, sites) {
      state.list = map(sites, site => {
        if (site instanceof Site) {
          return site
        } else {
          return new Site(site)
        }
      })
    },

    setSiteListMeta(state, meta) {
      state.listMeta = meta
    },

    clearSiteList(state) {
      state.list = []
      state.listMeta = {}
    },
    clearSiteListSelection(state) {
      state.siteSelectionList = []
      state.siteSelectionMeta = {}
    },

    setSiteDetails(state, site) {
      if (site instanceof Site) {
        state.siteDetails = site
      } else {
        state.siteDetails = new Site(site)
      }
    },

    clearSiteDetails(state) {
      state.siteDetails = null
    },

    setSiteListItemDetails(state, site) {
      const index = findIndex(state.list, { id: site.id })
      state.list[index].name = site.name
      state.list[index].address = site.address
      state.list[index].banner = site.banner
    },

    clearSiteListItemDetails(state, id) {
      const index = findIndex(state.list, { id: id })
      state.list.splice(index, 1)
    },

    setSiteBoardList(state, boards) {
      state.boardList = map(boards, board => {
        if (board instanceof Board) {
          return board
        } else {
          return new Board(board)
        }
      })
    },

    setSiteBoardListMeta(state, meta) {
      state.boardListMeta = meta
    },

    clearSiteBoardList(state) {
      state.boardList = []
      state.boardListMeta = {}
    }
  },

  actions: {
    async getSites({ commit, rootState }, params) {
      commit('setLoading', true)
      const { data } = await Api.get(
        `${params.selection ? '' : `users/${store.state.auth.user.id}/`}${
          params.selection ? 'site-manager/' : ''
        }sites?page=${params.page}&limit=${params.limit}${
          !params.selection && rootState.auth.user.is_admin
            ? '&include=banner'
            : ''
        }`
      )
      commit('setLoading', false)
      if (params.selection) {
        commit('setSiteSelectionList', data.data)
        commit('setSiteSelectionMeta', data.meta)
      } else {
        commit('setSiteList', data.data)
        commit('setSiteListMeta', data.meta)
      }
    },

    async getSiteBoards({ commit }, params) {
      const { data } = await Api.get(
        `sites/${params.site_id}/boards?page=${params.page}&limit=${
          params.limit
        }`
      )
      commit('setSiteBoardList', data.data)
      commit('setSiteBoardListMeta', data.meta)
    },

    async getSiteDetails({ commit }, id) {
      const { data } = await Api.get(`sites/${id}`)
      commit('setSiteDetails', data.data)
    },

    async createSite({ commit, state }, formData) {
      const { data } = await Api.post(`sites`, formData)
      state.list.unshift(data.data)
    },

    async updateSite({ commit, state }, formData) {
      await Api.put(`sites/${formData.id}`, formData)
    },

    async deleteSite({ commit, state }, id) {
      await Api.delete(`sites/${id}`)
      commit('clearSiteListItemDetails', id)
    },

    async removeUserFromSite({ commit }, formData) {
      await Api.delete(`/sites/${formData.site}/users/${formData.user}`)
    },

    async updateSiteCompliance({ commit }, formData) {
      await Api.put(`/sites/${formData.site_id}`, formData)
    }
  }
}
